import { type QueryHookOptions, useQuery } from "@apollo/client";
import { SubscriptionPurchasesQuery } from "../graphql/queries";
import type {
  SubscriptionPurchasesQueryType,
  SubscriptionPurchasesQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useSubscriptionPurchasesQuery = (
  options?: QueryHookOptions<
    SubscriptionPurchasesQueryType,
    SubscriptionPurchasesQueryVariablesType
  >
) => {
  return useQuery<
    SubscriptionPurchasesQueryType,
    SubscriptionPurchasesQueryVariablesType
  >(SubscriptionPurchasesQuery, options);
};
